module.exports = __webpack_public_path__ + "img/8blue.055bbc5c.png";